class NineSoleFit extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.hidden = false;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-nbj-sole], button[data-nbj-fit]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      const picker = this.closest('variant-picker');
      const native = picker?.querySelector('[data-nbj-combined]');
      const selected = native?.querySelector('input:checked')?.value || native?.querySelector('select')?.value;
      if (!selected) return;
      const [currentSole, currentFit = 'Standard fit'] = selected.split(' | ');
      const sole = button.dataset.nbjSole || currentSole;
      const fit = button.dataset.nbjFit || currentFit;
      const value = fit === 'Standard fit' ? sole : `${sole} | ${fit}`;
      const input = Array.from(native.querySelectorAll('input')).find((element) => element.value === value);
      const select = native.querySelector('select');
      if (!input && !select) return;
      this.querySelectorAll('[data-nbj-sole]').forEach((element) => element.setAttribute('aria-pressed', String(element.dataset.nbjSole === sole)));
      this.querySelectorAll('[data-nbj-fit]').forEach((element) => element.setAttribute('aria-pressed', String(element.dataset.nbjFit === fit)));
      if (input) {
        input.click();
      } else {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}
if (!customElements.get('nbj-sole-fit')) customElements.define('nbj-sole-fit', NineSoleFit);
